// extracted by mini-css-extract-plugin
module.exports = {"main":"main--3IYdt","wide":"wide--30RW5"};